import { da } from "element-plus/es/locale";

const POPUP_PREFIX_KEY = "popup_key_" as string;

export const shouldShowPopup = (key: string, showType: number): boolean => {
  const d = window.localStorage.getItem(POPUP_PREFIX_KEY + key);
  if (d) {
    const y: number = +d;
    const now = new Date().getTime();
    const milliseconds = now - y;
    const mins = Math.round(milliseconds / 60000);
    const hours = Math.floor(mins / 60);
    const days = Math.floor(hours / 24);
    /*     console.log(
      "y=%i now=%i mil=%i mins=%i hours=%i days=%i",
      y,
      now,
      milliseconds,
      mins,
      hours,
      days
    ); */
    switch (showType) {
      case 7: {
        if (mins > 15) {
          window.localStorage.setItem(POPUP_PREFIX_KEY + key, now.toString());
          return true;
        }
        break;
      }
      case 6: {
        if (mins > 60) {
          window.localStorage.setItem(POPUP_PREFIX_KEY + key, now.toString());
          return true;
        }
        break;
      }
      case 5: {
        if (days > 30) {
          window.localStorage.setItem(POPUP_PREFIX_KEY + key, now.toString());
          return true;
        }
        break;
      }
      case 4: {
        if (days > 7) {
          window.localStorage.setItem(POPUP_PREFIX_KEY + key, now.toString());
          return true;
        }
        break;
      }
      case 3: {
        if (days > 1) {
          window.localStorage.setItem(POPUP_PREFIX_KEY + key, now.toString());
          return true;
        }
        break;
      }
      case 2: {
        window.localStorage.setItem(POPUP_PREFIX_KEY + key, now.toString());
        return false;
      }
      case 1: {
        window.localStorage.setItem(POPUP_PREFIX_KEY + key, now.toString());
        return true;
      }
      default: {
        return false;
      }
    }
  } else {
    if (showType) {
      const now = new Date().getTime();
      window.localStorage.setItem(POPUP_PREFIX_KEY + key, now.toString());
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const clearPopupData = (key: string): void => {
  window.localStorage.removeItem(POPUP_PREFIX_KEY + key);
};

export default { shouldShowPopup, clearPopupData };
